import { CoreHelpContainer as CoreHelp } from './containers/';

export * from './containers/';

export { CoreHelp };
